export function RulerIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='24' height='24' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M13.2929 4.29286L14.7929 5.79286M10.2929 7.29286L11.7929 8.79286M7.29293 10.2929L8.79293 11.7929M4.29293 13.2929L5.79293 14.7929M1.35858 16.3586L5.22721 20.2272C5.42522 20.4252 5.52422 20.5242 5.63838 20.5613C5.73881 20.5939 5.84698 20.5939 5.9474 20.5613C6.06157 20.5242 6.16057 20.4252 6.35858 20.2272L20.2272 6.35858C20.4252 6.16057 20.5242 6.06157 20.5613 5.9474C20.5939 5.84698 20.5939 5.73881 20.5613 5.63838C20.5242 5.52422 20.4252 5.42522 20.2272 5.22721L16.3586 1.35858C16.1606 1.16057 16.0616 1.06157 15.9474 1.02447C15.847 0.991843 15.7388 0.991843 15.6384 1.02447C15.5242 1.06157 15.4252 1.16057 15.2272 1.35858L1.35858 15.2272C1.16057 15.4252 1.06157 15.5242 1.02447 15.6384C0.991843 15.7388 0.991843 15.847 1.02447 15.9474C1.06157 16.0616 1.16057 16.1606 1.35858 16.3586Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
